export default __webpack_public_path__ + "media/images/features/hida/title-left-975f4cd4ed04b47df650fc9075b037ed.png";